var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValuesSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.28 103.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#627172;}.cls-2{fill:#c9e8f0;}.cls-3{fill:#b99763;}.cls-4{fill:#987750;}.cls-5{fill:#a4ced5;}.cls-6{fill:#243a78;}.cls-7{fill:#e5ce40;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.27,2.87c-8.49-7.24-20.37.42-29.68,9.59S4.53,44.29,24.55,55c9.06,4.85,23,3.12,27.33.91C62.39,50.53,75.45,36,68.74,21.38,62.62,8,58.76,2.71,45.27,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.15,68.23c5,0,11.59-2.27,11.55-4.53v0C62.93,65.2,73.75,71,77.46,75.15s2.72,11.1,2.72,11.1-20.05,9.81-40.5,9.81S.12,86.25.12,86.25s-1-6.93,2.72-11.1,14.53-10,25.77-11.48l0,0c0,2.26,6.58,4.53,11.56,4.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.19,45c0,8.61,2.57,19.16,2.57,19.16,1.07,6.29-6.43,9.36-12.42,9.36s-14-4.09-13.91-8.16c0,0,2.85-13.78,1.66-19.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.19,47l-22.1.56c.51,2.72-.05,6.91-.47,10.83,4,4,7.54,6.61,12,5.9,3.42-.55,8.35-2.95,11.94-5.76C51.07,55,50.19,50.83,50.19,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.6,16.19c-3.51,7-5.33,24.75.77,31.33S34,59.26,39.71,58.28,54.39,50.45,55.82,45.7s6.63-14.13,3.51-21.82S45.91,11,40.34,11,23.6,16.19,23.6,16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.33,23.88C56.21,16.19,45.91,11,40.34,11a13.08,13.08,0,0,0-1.47.11l-.17,0c-.49.07-1,.16-1.52.26h0a59.25,59.25,0,0,0-9.1,2.89l-5.85,2.81c-2,4.68-2.22,14-1.51,21.1,9.65-1.91,11.36-11.84,21.37-12.66S57.53,40.4,57.48,41.2C59.38,36.21,61.65,29.59,59.33,23.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,9.69C42.6,17.23,32.55,32.77,13.41,33L16,15.11,36.17,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.48,11c.58,8.41,20.47,14.14,22,24.58s5.82-13.28,5.82-13.28-2-11-8.31-12.71S37.9,2.66,38.48,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.2,71a24.83,24.83,0,0,0-5.36,4.2C-.86,79.32.12,86.25.12,86.25s19.12,9.81,39.56,9.81,40.5-9.81,40.5-9.81a17.48,17.48,0,0,0-1.32-9h0C72.3,83.83,32.59,92.12,8.2,71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.19,80a7.46,7.46,0,0,0-10.46-1.43L57.8,80l-1.46-1.93a7.47,7.47,0,0,0-11.9,9L45.9,89l9,11.89,11.9-9,1.92-1.46A7.46,7.46,0,0,0,70.19,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M9.39,57.14a12.71,12.71,0,0,0,4.67,4.68.57.57,0,0,1,0,1,12.76,12.76,0,0,0-4.67,4.67.57.57,0,0,1-1,0,12.71,12.71,0,0,0-4.68-4.67.58.58,0,0,1,0-1,12.66,12.66,0,0,0,4.68-4.68A.58.58,0,0,1,9.39,57.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25.74,97.57a7.57,7.57,0,0,0,2.78,2.78.34.34,0,0,1,0,.6,7.57,7.57,0,0,0-2.78,2.78.34.34,0,0,1-.6,0A7.57,7.57,0,0,0,22.36,101a.34.34,0,0,1,0-.6,7.57,7.57,0,0,0,2.78-2.78A.34.34,0,0,1,25.74,97.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.31,62.05a12,12,0,0,0-9-9,.34.34,0,0,1,0-.67,12,12,0,0,0,9-9,.34.34,0,0,1,.67,0,12,12,0,0,0,9,9A.34.34,0,0,1,83,53a12,12,0,0,0-9,9A.34.34,0,0,1,73.31,62.05Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuesSection);
export default __webpack_public_path__ + "static/media/values_section.1a9b8227e88e6529909b5409bcfaaf08.svg";
export { ForwardRef as ReactComponent };